/* global axios */
import ApiClient from '../ApiClient';

class AilabResponses extends ApiClient {
  constructor() {
    super('ailab/assistant_responses', { accountScoped: true });
  }

  get({ page = 1, search, assistantId, documentId, status } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search,
        assistant_id: assistantId,
        document_id: documentId,
        status,
      },
    });
  }

  // Quick-add — used by the Voice Playground's "add to Q&A" flow.
  // Same endpoint the AILAB assistant editor uses; status defaults to
  // 'approved' so the answer goes live for the receptionist immediately.
  create({ assistantId, question, answer, status = 'approved' }) {
    return axios.post(this.url, {
      assistant_response: {
        assistant_id: assistantId,
        question,
        answer,
        status,
      },
    });
  }

  // Bulk import — used by the Voice Playground starter templates.
  // responses: [{ question, answer }, ...]. Backend dedupes by
  // question text (case-insensitive) for this assistant.
  bulkCreate({ assistantId, responses, status = 'approved' }) {
    return axios.post(`${this.url}/bulk`, {
      assistant_id: assistantId,
      responses,
      status,
    });
  }

  // Edit / delete an existing Q&A row. Used by the sidebar's
  // click-to-edit flow on the Voice Playground. Same endpoints the
  // AILAB editor uses — no new backend surface.
  update(id, { question, answer, status } = {}) {
    const payload = {};
    if (question !== undefined) payload.question = question;
    if (answer !== undefined) payload.answer = answer;
    if (status !== undefined) payload.status = status;
    return axios.patch(`${this.url}/${id}`, { assistant_response: payload });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new AilabResponses();
